import {Component} from 'react'
import Link from '../links/RouterLink'

const Category = (props) => (
    <li key={props.slug}>
        <Link route="category"  params={{cat_slug : props.slug}}>
            {props.title}
        </Link>
    </li>
)

class Categories extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="headline">
                    <h2>Top Categories</h2>
                </div>
                <ul className="list sidebar-block">
                    {this.props.cats.map(Category)}
                </ul>
            </div>
        )
    }
}

export default Categories



// WEBPACK FOOTER //
// components/sidebars/Categories.js